// The territory catalogue (12 October 2026).
export default {
  titre: 'Catalogue',
  sousTitre: 'Every Orion territory · {n} in your radar',
  sousTitreAucun: 'Every Orion territory',
  chargement: 'Loading the catalogue…',
  erreur: 'The catalogue did not load.',
  reessayer: 'Try again',
  fermer: 'Close',
  recherche: 'Search a territory',
  rechercheAria: 'Search a territory by name',
  vue: { aria: 'Which territories', tous: 'All', radar: 'In my radar', disponibles: 'To add' },
  familles: {
    aria: 'Families',
    toutes: 'All',
    pays: 'Countries',
    regions: 'Regions and cities',
    continents: 'Continents',
    chaines: 'Channels',
    plateformes: 'Platforms and networks',
    thematiques: 'Topics',
    jeunes: 'Young audiences',
    electorats: 'Electorates',
  },
  dispo: { suivi: 'Followed daily', sous_24h: 'Ready within 24 h', sur_demande: 'On request' },
  tailleInconnue: 'Size not published',
  recoupe: '{pct}% overlap with {nom}',
  legende: 'Overlap: how close it is to what you already follow, two audiences talking about the same topics.',
  ajouter: 'Add to my radar',
  ajout: 'Adding…',
  dansRadar: 'In your radar',
  retirer: 'Remove',
  retirerAria: 'Remove {nom} from my radar',
  ajouterAria: 'Add {nom} to my radar',
  ouvertParOrion: 'Opened by the Orion team',
  surDemande: 'The Orion team opens electorates on request.',
  toutVoir: 'See all {n} territories',
  moins: 'Show less',
  aucun: 'No territory matches.',
  ajoute: {
    suivi: '{nom} is in your radar.',
    patrouille: '{nom} is in your radar: its first readings arrive tomorrow morning.',
    synthese: '{nom} is in your radar: Orion is preparing it, ready within 24 h.',
    sans_fuseau: '{nom} is in your radar: the Orion team is finishing its setup.',
  },
  retire: '{nom} has left your radar.',
}
